import React from "react";
import styled from "styled-components";
import { ReactComponent as CustomSVG } from "../assets/shapes/Subtract.svg";
import SwapIcon from "../assets/icons/swap.svg";
import WithdrawIcon from "../assets/icons/withdraw.svg";
// import { useTonConnectUI, useTonAddress } from "@tonconnect/ui-react";
import { useEffect, useState } from "react";
import { SecondaryButton } from "./styled";
import WithdrawalModalContent from "./withdrawModalContent";
import {useBottomSheet} from "../context/BottomSheetContext";
import { useUserContext } from "../context/UserContext";
import USD1Icon from "../assets/images/logo/tokens/usd1.png";
import FourMemeIcon from "../assets/images/logo/tokens/fourmeme.svg";
import { useDisconnect } from "wagmi";


const ProfileCard = () => {
  const { disconnectAsync } = useDisconnect();
  const wallet = "";
  const {openSheet,closeSheet} = useBottomSheet();
  const {user,logout}=useUserContext()
  // const { user, error } = useTelegramUser();
  const [userData, setUserData] = useState({
    profilePicture:
      "",
    username: "unknown",
    wallet: "",
  });

  const openWithdrawModal = () => {
    openSheet({content: <WithdrawalModalContent closeSheet={closeSheet} />, title: "Withdraw"});
  };

  useEffect(() => {
    if (user) {
      setUserData({
        profilePicture: user.telegramPhotoUri,
        username: user.username,
        wallet: wallet,
      });
    }
  }, [user]);
  const handleLogout = async () => {
        try {
      await disconnectAsync();
      logout();
    } catch (e) {
        console.error("Disconnect error:", e);
    }
  };
  return (
    <ProfileContainer>
      <CustomSVG />
      <Cirkle>
        <Avatar src={userData.profilePicture} />
      </Cirkle>
      <ProfileDetails>
        <UsernameField>@{userData.username}</UsernameField>
        <SecondaryButton
          onClick={handleLogout}
        >
          Log out
        </SecondaryButton>
      </ProfileDetails>
      <BottomCirkle style={{ left: "6.3%" }}>
        <IconContainer onClick={openWithdrawModal}>
          <IconImage src={WithdrawIcon} />
        </IconContainer>
        <Text>Withdraw</Text>
      </BottomCirkle>
      <BottomCirkle style={{ left: "36.6%" }}>
        <IconContainer onClick={()=>window.open("https://pancakeswap.finance/swap?chain=bsc&outputCurrency=0x2F732Ed9DBE616E7aa20F3123856d9636a394444")}>
          <IconImage src={SwapIcon} />
          <BadgeIcon >
            <img src={USD1Icon} width={"100%"}/>
          </BadgeIcon>
        </IconContainer>
        <Text>Swap</Text>
      </BottomCirkle>
      <BottomCirkle style={{ right: "6.3%" }}>
        <IconContainer onClick={()=>window.open("https://four.meme/token/0x2f732ed9dbe616e7aa20f3123856d9636a394444")}>
          <IconImage src={SwapIcon} />
          <BadgeIcon >
            <img src={FourMemeIcon} width={"100%"}/>
          </BadgeIcon>
        </IconContainer>
        <Text>Four Meme</Text>
      </BottomCirkle>
    </ProfileContainer>
  );
};

const ProfileContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-top: 10vh;
  margin-bottom: 10%;
  svg {
    width: 100%;
    height: auto;
  }
`;
const ProfileDetails = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  height: 80px;
  align-items: center;
  justify-content: space-between;
`;
const Cirkle = styled.div`
  width: 28%;
  aspect-ratio: 1/1;
  height: auto;
  background-color: rgba(40, 40, 40, 0.3);
  border: 2px solid #ffffff;
  z-index: 1;
  position: absolute;
  border-radius: 50%;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0) translateY(-50%);
  overflow: hidden;
`;

const BottomCirkle = styled.div`
  width: 27%;
  aspect-ratio: 1/1;
  height: auto;
  background-color: rgba(40, 40, 40, 0.3);
  border: 1px solid #7455bf;
  z-index: 1;
  position: absolute;
  border-radius: 50%;
  bottom: -13%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const IconContainer = styled.span`
  width: 50%;
  aspect-ratio: 1/1;
  background-color: #6939ada1;
  border-radius: 50%;
  border: 0.88px solid #ffffff;
  backdrop-filter: blur(9.502815246582031px);
  box-shadow: 0px 3.52px 0px 0px #6747ac;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;
const BadgeIcon = styled.span`
  position: absolute;
  top: -7px;
  right: -13px;
  width: 27px;
  height: 27px;
  border-radius: 100px;
  background-color: #19102E;
  padding: 4px
`;
const IconImage = styled.img`
  width: 50%;
`;
const Text = styled.span`
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  margin-top: 6px;
`;
const Avatar = styled.img`
  width: 100%;
  height: auto;
  border-radius: 50%;
  aspect-ratio: 1/1;
`;
const UsernameField = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.text.light};
`;

export default ProfileCard;
